module.exports = __webpack_public_path__ + "media/images/list-f793ac69ace1e306feda54a6ad38c8f8.svg";